import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import i18n from './app/lib/i18n';
import { langFromPath } from './app/lib/site';
import { AppRoutes } from './app/router/routes';
import { captureUtm, initAnalytics, installLinkDecorator } from './app/lib/analytics';
import './theme/main.css';

captureUtm();
initAnalytics();
installLinkDecorator();

const container = document.getElementById('root')!;
const pathname = window.location.pathname;

i18n.changeLanguage(langFromPath(pathname));

const app = (
  <StrictMode>
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  </StrictMode>
);

// Гидратируем только если HTML был пререндерен именно для этого пути.
// Иначе (например, 404.html, отданный на произвольный адрес) — обычный рендер.
const norm = (p: string) => (p.endsWith('/') ? p : `${p}/`);
const ssrPath = container.dataset.ssrPath;

if (ssrPath && container.hasChildNodes() && norm(ssrPath) === norm(pathname)) {
  hydrateRoot(container, app);
} else {
  container.innerHTML = '';
  createRoot(container).render(app);
}
